var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.09761 11.7779C1.36121 12.0708 1.7886 12.0708 2.0522 11.7779L6.2999 7.05822L9.69154 10.8267C9.82675 10.9769 10.013 11.0564 10.2039 11.0454C10.3949 11.0343 10.5727 10.9338 10.6931 10.7688C12.2157 8.68261 13.3991 6.23879 14.1244 3.51507L15.5416 6.24236C15.728 6.60108 16.1408 6.72399 16.4636 6.51688C16.7865 6.30978 16.8971 5.85108 16.7107 5.49236L14.4833 1.20576C14.2969 0.847036 13.8841 0.724131 13.5612 0.931237L9.70329 3.40611C9.38045 3.61322 9.26983 4.07191 9.45623 4.43063C9.64262 4.78935 10.0554 4.91226 10.3783 4.70515L12.816 3.14135C12.2166 5.36991 11.2876 7.39354 10.1049 9.16471L6.7772 5.46723C6.65061 5.32658 6.47892 5.24756 6.2999 5.24756C6.12088 5.24756 5.94919 5.32658 5.82261 5.46723L1.09761 10.7172C0.834001 11.0101 0.834001 11.485 1.09761 11.7779Z",
    fill: "#18B368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateIcon);
export default __webpack_public_path__ + "static/media/rateIcon.59a231f85a438aaebf60057ad99d58cc.svg";
export { ForwardRef as ReactComponent };